const s = {
  ".bmp": "/icons/file_types/bmp.svg",
  ".csv": "/icons/file_types/csv.svg",
  ".dg2": "/icons/file_types/dg2.svg",
  ".dgr": "/icons/file_types/dgr.svg",
  ".doc": "/icons/file_types/doc.svg",
  ".docx": "/icons/file_types/docx.svg",
  ".forma": "/icons/file_types/forma.svg",
  ".gif": "/icons/file_types/gif.svg",
  ".jpg": "/icons/file_types/jpg.svg",
  ".jpeg": "/icons/file_types/jpg.svg",
  ".key": "/icons/file_types/keynote.svg",
  ".keynote": "/icons/file_types/keynote.svg",
  ".numbers": "/icons/file_types/numbers.svg",
  ".pages": "/icons/file_types/pages.svg",
  ".pdf": "/icons/file_types/pdf.svg",
  ".png": "/icons/file_types/png.svg",
  ".ppt": "/icons/file_types/ppt.svg",
  ".pptx": "/icons/file_types/pptx.svg",
  ".tif": "/icons/file_types/tif.svg",
  ".tiff": "/icons/file_types/tif.svg",
  ".txt": "/icons/file_types/txt.svg",
  ".xls": "/icons/file_types/xls.svg",
  ".xlsx": "/icons/file_types/xlsx.svg",
  ".zip": "/icons/file_types/zip.svg",
  other: "/icons/file_types/other.svg"
}, e = {
  images: {
    "image/bmp": [".bmp"],
    "image/png": [".png"],
    "image/gif": [".gif"],
    "image/jpeg": [".jpg", ".jpeg"],
    "image/webp": [".webp"],
    "image/tiff": [".tif", ".tiff"]
  },
  documents: {
    "application/msword": [".doc"],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
    "application/vnd.ms-excel": [".xls"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
    "application/vnd.oasis.opendocument.spreadsheet": [".ods"],
    "application/vnd.oasis.opendocument.text": [".odt"],
    "application/pdf": [".pdf"],
    "application/rtf": [".rtf"],
    "text/plain": [".txt"]
  },
  archives: {
    "application/zip": [".zip"],
    "application/vnd.rar": [".rar"]
  }
};
export {
  e as fileTypes,
  s as filesIcons
};
